import styled from './contatos.module.css';
import Header from '../../components/Header';
import Menu from '../../components/Menu';
import { CiMail } from 'react-icons/ci';
import { BsWhatsapp, BsTelephone } from 'react-icons/bs';
import api from '../../services/api';
import { useEffect, useState,useCallback } from 'react';
import { Alerta } from '../../utils/functions';
import { GoogleMap, useJsApiLoader, MarkerF } from '@react-google-maps/api';



function Contatos() {
    const login = JSON.parse(localStorage.getItem("login"));
    const nomcli = login.nomcli;
    const cgccli = login.cgccli;
    const [nomven, setNomven] = useState('');
    const [telven, setTelven] = useState('');
    const [fotven, setFotven] = useState('');
    const [map, setMap] = useState(null)

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyBtFKaxN9208cweDheoIxFovbgrY82R1y0"
    })

    const opt = {
        streetViewControl:true,zoomControl:false,mapTypeControl:false
    }

    const position = {
        lat: -20.8059309,
        lng: -49.4896163
    }

    const label = {
        label: {
            text: "Cozimax Móveis Mirassol",
            className: "marker"

        }
    }


    async function GetDados() {
        await api.get(`info/consultor?cgccli=${cgccli}`)
            .then((response) => {
                if (!response.data.msg) {
                    setNomven(response.data.nomfan);
                    setTelven(response.data.fonven);
                    setFotven(response.data.fotpro);
                } else {
                    Alerta('Erro', response.data.msg, 'error');
                }
            }).catch((erro) => {
                Alerta('Erro', erro, 'error');
            })
    }

    useEffect(() => {
        GetDados();

    }, [])

    return (
        <div className={styled.page}>
            <Menu menu="contatos" />
            <div className={styled.container}>
                <Header page="Contatos" />
                <div className={styled.frame101}>
                    <div className={styled.cardendereco}>
                        <div className={styled.cardenderecoheader}>
                            <div className={styled.cardenderecotitle}>
                                <a>Onde estamos</a>
                                <div className={styled.cardenderecoline}></div>
                            </div>
                        </div>
                        <div className={styled.cardenderecocontent}>
                            <div className={styled.cardenderecoapp}>
                                <div className={styled.cardenderecoframe99}>
                                    <a>A Cozimax está localizada na</a>
                                    <span>Avenida Nilo Pandolphi, 36-56,
                                        Parque Industrial, Mirassol - SP
                                        CEP: 15134-000
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                    {/*<div className={styled.divmap}>
                        {isLoaded ? (
                            <GoogleMap
                                mapContainerStyle={{width: "100%",height: "100%"}}
                                center={position}
                                zoom={15}
                                options={opt}
                            >
                                <MarkerF position={position} options={label}/>
                                <></>
                            </GoogleMap>
                        ) : <></>}
                        </div>*/}

                    <div className={styled.cardmensagem}>
                        <div className={styled.imglocal}></div>
                        {/*<div className={styled.cardmensagemcontent}>
                            
                            <div className={styled.cardmensagemslot}>
                                <div className={styled.cardmensagemslotrect}></div>
                                
                            </div>
                        </div>*/}
                    </div>

                </div>
                <div className={styled.cardfale}>
                    <div className={styled.cardfaleheader}>
                        <div className={styled.cardfaletitle}>
                            <a>Comercial</a>
                            <div className={styled.cardenderecoline}></div>
                        </div>
                    </div>
                    <div className={styled.cardfalecontent}>
                        <div className={styled.cardfaleapp}>
                            <div className={styled.cardfale101}>
                                <div className={styled.cardfale99}>
                                    <a>Atendimento via telefone, e-mail e whatsapp</a>
                                    <div className={styled.cardfaledia}>
                                        <a>Segunda à Sexta,</a>
                                        <a>7h - 11h30 e 13h - 17h</a>
                                    </div>

                                </div>
                                <div className={styled.cardconsultor}>
                                    <div className={styled.cardfalecomercial}>
                                        <div className={styled.cardfaleframe97}>
                                            <a>Consultor</a>
                                        </div>
                                        <div className={styled.cardfalecomercialframe101}>
                                            <div className={styled.cardfalecomercialemail}>
                                                <a>{nomven}</a>
                                            </div>
                                            <div className={styled.cardfalecomercialwats}>
                                                <div className={styled.cardfalecomercialwatsdiv}>
                                                    <BsTelephone size={16} />
                                                    <a >{telven}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styled.cardfotoconsultor}>
                                        <img className={styled.foto} src={`data:image/jpeg;base64,${fotven}`} />
                                    </div>
                                </div>
                            </div>
                            <div className={styled.cardfale102}>
                                <div className={styled.cardfabrica}>
                                    <div className={styled.cardfabrica97}>
                                        <a>Atendimento</a>
                                    </div>
                                    <div className={styled.cardfabrica101}>
                                        <div className={styled.cardfabricaemail}>
                                            <div className={styled.cardfabricaemailcontent}>
                                                <CiMail size={16} />
                                                <a>atendimento@cozimax.com.br</a>
                                            </div>
                                        </div>
                                        <div className={styled.cardfabricawats}>
                                            <div className={styled.cardfabricawatscontent}>
                                                <BsWhatsapp className={styled.iconwats} size={16} />
                                                <a href={`https://wa.me/5517981740347?text=Olá! Sou da Empresa : ${nomcli}`}
                                                    target="_blank" rel="noopener noreferrer">(17) 98174-0347</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={styled.cardfabrica}>
                                    <div className={styled.cardfabrica97}>
                                        <a>ASSISTÊNCIA</a>
                                    </div>
                                    <div className={styled.cardfabrica101}>
                                        <div className={styled.cardfabricaemail}>
                                            <div className={styled.cardfabricaemailcontent}>
                                                <CiMail size={16} />
                                                <a>assistencia@cozimax.com.br</a>
                                            </div>
                                        </div>
                                        <div className={styled.cardfabricawats}>
                                            <div className={styled.cardfabricawatscontent}>
                                                <BsWhatsapp className={styled.iconwats} size={16} />
                                                <a href={`https://wa.me/5517991253851?text=Olá! Sou da Empresa : ${nomcli}`}
                                                    target="_blank" rel="noopener noreferrer">(17) 99125-3851</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={styled.cardfabrica}>
                                    <div className={styled.cardfabrica97}>
                                        <a>FINANCEIRO</a>
                                    </div>
                                    <div className={styled.cardfabrica101}>
                                        <div className={styled.cardfabricaemail}>
                                            <div className={styled.cardfabricaemailcontent}>
                                                <CiMail size={16} />
                                                <a>cobranca@cozimax.com.br</a>
                                            </div>
                                        </div>
                                        <div className={styled.cardfabricawats}>
                                            <div className={styled.cardfabricawatscontent}>
                                                <BsWhatsapp className={styled.iconwats} size={16} />
                                                <a href={`https://wa.me/5517991236900?text=Olá! Sou da Empresa : ${nomcli}`}
                                                    target="_blank" rel="noopener noreferrer">(17) 99123-6900</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={styled.cardfabrica}>
                                    <div className={styled.cardfabrica97}>
                                        <a>LOGÍSTICA</a>
                                    </div>
                                    <div className={styled.cardfabrica101}>
                                        <div className={styled.cardfabricaemail}>
                                            <div className={styled.cardfabricaemailcontent}>
                                                <CiMail size={16} />
                                                <a>faturamento@cozimax.com.br</a>
                                            </div>
                                        </div>
                                        <div className={styled.cardfabricawats}>
                                            <div className={styled.cardfabricawatscontent}>
                                                <BsWhatsapp className={styled.iconwats} size={16} />
                                                <a href={`https://wa.me/5517991078280?text=Olá! Sou da Empresa : ${nomcli}`}
                                                    target="_blank" rel="noopener noreferrer">(17) 99107-8280</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Contatos;